import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import RelevantItemsTabState from './RelevantItemsTabState';
import RelevantItemsView from './RelevantItemsView';

export default class RelevantItemsTabView extends BufferTabView<RelevantItemsTabState> {
  initialize(): void {
    this.listenTo(this.model, 'change', () => {
      this.render();
    });
  }

  render(): this {
    const model = this.model.get('model');
    ReduxDOMRender.renderToDOM(<RelevantItemsView fileId={model.id} fileName={model.name()} />, this.el);
    return this;
  }

  remove(): Backbone.View<RelevantItemsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RelevantItemsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
